import React from 'react'
import { VideoSquare } from 'iconsax-react'
import { useTheme } from '@mui/material'

import ClickableAlt from '../ClickableAlt'
import LoadingIndicator from '../LoadingIndicator'

import { UseMediaHandleType } from '../../../../../hooks/useMediaHandle'
import useStyles from './styles'

type VideoProps = {
  mediaHandle: UseMediaHandleType
  onClick: () => void
}

const Video: React.FC<VideoProps> = ({ mediaHandle, onClick }) => {
  const theme = useTheme()

  const { media, srcURL, downloadAfterLoad, loading, startLoad } = mediaHandle

  const classes = useStyles()

  return (
    <>
      <VideoSquare
        size={theme.size.xxxl}
        variant='Bold'
        color={theme.palette.primary.main}
        className={classes.icon}
      />

      <ClickableAlt onClick={onClick}>{media.filename}</ClickableAlt>

      {srcURL ? (
        <video
          controls
          loop
          autoPlay={!downloadAfterLoad}
          src={srcURL}
          className={classes.video}
        />
      ) : (
        <LoadingIndicator loading={loading} onClick={startLoad} />
      )}
    </>
  )
}

export default Video
